window.TVOPLAY_STATE = {
  loading: true,

  /*
    Subscription
  */
  hasSubscription: false,
  currentSku: null,
  status: null,

  /*
    Onboarding
  */
  onboardingStatus: null,
  requiresPasswordSetup: false,

  /*
    Mutation
  */
  activeMutation: false,
  mutation: null,
};

const TVOPLAY_HOME_POLL_INTERVAL_MS =
  4000;

const TVOPLAY_HOME_POLL_MAX_ATTEMPTS =
  30;

let tvoplayHomePollAttempts =
  0;

let tvoplayHomePollTimer =
  null;

function isTVOplayHomePage() {

  return (window.location.pathname.replace(/\/+$/, '') || '/') === '/';

}

async function bootstrapTVOplayState() {

  const customer =
    window.TVOPLAY_CUSTOMER;

  if (!customer?.loggedIn || !customer?.id) {

    window.TVOPLAY_STATE.loading =
      false;

    return;

  }

  try {

    const response = await fetch(
      `https://api.tvoplay.com/api/v1/customer/subscription-state?shopify_customer_id=${encodeURIComponent(
        customer.id
      )}`,
      {
        cache:
          'no-store',
      }
    );

    if (!response.ok) {

      throw new Error(
        `HTTP ${response.status}`
      );

    }

    const data =
      await response.json();

    window.TVOPLAY_STATE = {

      loading: false,

      /*
        Subscription
      */
      hasSubscription:
        data.has_subscription,

      currentSku:
        data.current_sku,

      status:
        data.status,

      /*
        Onboarding
      */
      onboardingStatus:
        data.onboarding_status,

      requiresPasswordSetup:
        data.requires_password_setup,

      /*
        Mutation
      */
      activeMutation:
        data.active_mutation,

      mutation:
        data.mutation
          ? {

              /*
                Identity
              */
              id:
                data.mutation.id,

              type:
                data.mutation.type,

              status:
                data.mutation.status,

              /*
                Plan transition
              */
              currentSku:
                data.mutation.current_sku,

              targetSku:
                data.mutation.target_sku,

              /*
                Mutation actions
              */
              effectiveNow:
                data.mutation.effective_now || [],

              effectiveNextCycle:
                data.mutation.effective_next_cycle || [],

              /*
                Dates
              */
              scheduledFor:
                data.mutation.scheduled_for,

              effectiveAt:
                data.mutation.effective_at,

              createdAt:
                data.mutation.created_at,

              /*
                Behavior
              */
              blocking:
                data.mutation.blocking,

              providerSyncRequired:
                data.mutation.provider_sync_required,

              undoAllowed:
                data.mutation.undo_allowed,

              checkoutUrl:
                data.mutation.checkout_url,

              /*
                UX
              */
              message:
                data.mutation.message,
            }
          : null,
    };

    console.log(
      'TVOplay state loaded',
      window.TVOPLAY_STATE
    );

    document.dispatchEvent(
      new CustomEvent(
        'tvoplay:state-ready',
        {
          detail:
            window.TVOPLAY_STATE,
        }
      )
    );

    if (
      isTVOplayHomePage()
      && !window.TVOPLAY_STATE.hasSubscription
    ) {

      startTVOplayHomePolling();

    }

  } catch (error) {

    console.error(
      'TVOplay bootstrap failed',
      error
    );

    window.TVOPLAY_STATE.loading =
      false;

    if (isTVOplayHomePage()) {

      startTVOplayHomePolling();

    }

  }

}

bootstrapTVOplayState();

function startTVOplayHomePolling() {

  if (tvoplayHomePollTimer) {
    return;
  }

  tvoplayHomePollTimer = window.setInterval(
    async () => {

      if (!isTVOplayHomePage()) {
        stopTVOplayHomePolling();
        return;
      }

      if (window.TVOPLAY_STATE.hasSubscription) {
        stopTVOplayHomePolling();
        return;
      }

      if (document.visibilityState === 'hidden') {
        return;
      }

      tvoplayHomePollAttempts +=
        1;

      if (tvoplayHomePollAttempts > TVOPLAY_HOME_POLL_MAX_ATTEMPTS) {
        stopTVOplayHomePolling();
        return;
      }

      await bootstrapTVOplayState();

    },
    TVOPLAY_HOME_POLL_INTERVAL_MS
  );

}

function stopTVOplayHomePolling() {

  if (!tvoplayHomePollTimer) {
    return;
  }

  window.clearInterval(
    tvoplayHomePollTimer
  );

  tvoplayHomePollTimer =
    null;

}

/*
  Navigation
*/
document.addEventListener(
  'tvoplay:state-ready',
  () => {

    const state =
      window.TVOPLAY_STATE;

    const plans =
      document.getElementById(
        'tvoplay-nav-plans'
      );

    const subscription =
      document.getElementById(
        'tvoplay-nav-subscription'
      );

    if (!state.hasSubscription) {
      return;
    }

    if (plans) {

      plans.style.display =
        'none';

    }

    if (subscription) {

      subscription.style.display =
        'list-item';

    }

  }
);

/*
  Homepage guard
*/
document.addEventListener(
  'tvoplay:state-ready',
  () => {

    const state =
      window.TVOPLAY_STATE;

    if (!state.hasSubscription) {
      return;
    }

    const currentPath =
      window.location.pathname.replace(/\/+$/, '') || '/';

    if (currentPath !== '/') {
      return;
    }

    window.location.replace(
      '/pages/subscription'
    );

  }
);

/*
  Buy / Manage CTA
*/
document.addEventListener(
  'tvoplay:state-ready',
  () => {

    const state =
      window.TVOPLAY_STATE;

    if (!state.hasSubscription) {
      return;
    }

    const normalBuy =
      document.getElementById(
        'tvoplay-normal-buy'
      );

    const manageSubscription =
      document.getElementById(
        'tvoplay-manage-subscription'
      );

    if (normalBuy) {

      normalBuy.style.display =
        'none';

    }

    if (manageSubscription) {

      manageSubscription.style.display =
        'block';

    }

  }
);
